import { Icon } from "@introist/react-foundation/v2";
import { TemplatesRoute } from "./routes/TemplatesRoute";
import { TemplateViewerRoute } from "./routes/TemplateViewerRoute";

export const TEMPLATES_ROUTES = {
  templates: {
    key: "route-templates",
    title: "Library",
    icon: <Icon name="templates" />,
    path: "/templates",
    element: <TemplatesRoute />
  },
  template: {
    key: "route-template",
    title: "Template",
    path: "/templates/:id",
    element: <TemplateViewerRoute />
  },
  templateStep: {
    key: "route-template-step",
    title: "Template Step",
    path: "/templates/:id/:stepId",
    element: <TemplateViewerRoute />
  }
};

export * from "./routes/TemplatesRoute";
export * from "./routes/TemplateViewerRoute";
